import { render } from "./FooterView.vue?vue&type=template&id=321b0954&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=321b0954&scoped=true&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321b0954"]])

export default __exports__